import { render, staticRenderFns } from "./FollowUpReports.vue?vue&type=template&id=085fb1ab&scoped=true&"
import script from "./FollowUpReports.vue?vue&type=script&lang=js&"
export * from "./FollowUpReports.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpReports.vue?vue&type=style&index=0&id=085fb1ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085fb1ab",
  null
  
)

export default component.exports